import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Image } from '../../../models/image/image';

@Component({
	selector: 'app-atom-media-player',
	templateUrl: './atom-media-player.component.html',
	styleUrls: ['./atom-media-player.component.less'],
})
export class AtomMediaPlayerComponent {
	@Input() media: Image;

	constructor(private sanitizer: DomSanitizer) {}

	getSourceUrl(): string {
		return this.media.getUrl();
	}

	getMediaType(): string {
		return this.media.constructor.name.toLowerCase();
	}

	bypassUrl(url: string) {
		return this.sanitizer.bypassSecurityTrustResourceUrl(url);
	}
}
